import { BehaviorSubject } from '@contorion/core';
import { ITouchExtended } from '../interfaces/touch-extended.interface';

export class NavigationService {
    public lastScreenX: BehaviorSubject<number> = new BehaviorSubject(null);

    public activeMenu: BehaviorSubject<string> = new BehaviorSubject(null);

    public touchStart: BehaviorSubject<ITouchExtended> = new BehaviorSubject(null);

    public lastTouch: BehaviorSubject<Touch> = new BehaviorSubject(null);

    public navigationIsActive: BehaviorSubject<boolean> = new BehaviorSubject(false);
}

export const navigationService = new NavigationService();
